module.exports = __webpack_public_path__ + "media/en_gb_s1_Alen.35d161ab.mp3";